import { debug } from "util";

cb.define([], function () {
  var AA_aa_enumext_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    typeChange(viewmodel,enumextValueModel){
      var value=viewmodel.get('type').getValue();

      if(value=='Integer'){
        enumextValueModel.setColumnState('enumName','cControlType','inputNumber');
        enumextValueModel.setColumnState('enumName','iNumPoint','0');
        viewmodel.get('decimalDigits').setVisible(false);
      }else if(value=='Double'){
        viewmodel.get('decimalDigits').setVisible(true);
        enumextValueModel.setColumnState('enumName','cControlType','inputNumber');
      }else if(value=='Date'){
        viewmodel.get('decimalDigits').setVisible(false);
        enumextValueModel.setColumnState('enumName','cControlType','datepicker');
      }else{
        viewmodel.get('decimalDigits').setVisible(false);
        enumextValueModel.setColumnState('enumName','cControlType','input');
      }
    },

    init: function (viewmodel) {
      var self = this;
      var enumextValueModel = viewmodel.get("enumExtValues");
      viewmodel.on('afterLoadData', function () {
        self.typeChange(viewmodel, enumextValueModel);
        var value = viewmodel.get('decimalDigits').getValue();
        if (value) {
          enumextValueModel.setColumnState('enumName', 'iNumPoint', value);
        }
        //  enumextValueModel.setColumnState('icon','bCanModify',false);
      });
      viewmodel.get('type').on("afterValueChange", function (data) {
        self.typeChange(viewmodel, enumextValueModel);
      });
      viewmodel.get('decimalDigits').on("afterValueChange", function (data) {
        var value = viewmodel.get('decimalDigits').getValue();
        if (value) {
          enumextValueModel.setColumnState('enumName', 'iNumPoint', value);
        }
      });
      viewmodel.get('length').on("afterValueChange", function (data) {
        var value = viewmodel.get('length').getValue();
        if (value) {
          if (value > 255 || value < 0) {
            cb.utils.alert("非法枚举长度,长度最大值255，最小值0");
            return false;
          }
        }
      });
      if (enumextValueModel) {
        enumextValueModel.on('beforeCellValueChange', function (data) {
          var length = viewmodel.get('length').getValue();
          if (data.cellName == 'enumName') {  //按钮名称
            if(data.value && (data.value.length>255 || (length && data.value.length>length)  )){
              cb.utils.alert("枚举值名称长度非法");
              return false;
            }
          }
        });
      }


      // var enumModel=viewmodel.getGridModel("enumExtValues");
      // enumModel.on('rowColChange', function (args) {
      //   var promise = new cb.promise();
      //   var id = viewmodel.get('id').getValue();
      //   var code = viewmodel.get('code').getValue();
      //   var name = viewmodel.get('name').getValue();

      //   var url = '/enum/enumCheck';
      //   var params = {"id":id, "code":code, "name":name};
      //   var proxy = cb.rest.DynamicProxy.create({ ensure: { url: url, method: "POST" } });
      //   proxy.ensure(params, function (err, result) {
      //     if (err) {
      //       cb.utils.alert(err.message, 'error');
      //       return ;
      //     }
      //     promise.resolve();
      //   });

      //   return promise;

      //   });

      viewmodel.on('beforeDeleteRow', function (args) {
        var promise = new cb.promise();
        var id = viewmodel.get('id').getValue();
        var code = viewmodel.get('code').getValue();
        var name = viewmodel.get('name').getValue();
        var url = '/enum/enumCheck';
        var params = {"id":id, "code":code, "name":name};
        var proxy = cb.rest.DynamicProxy.create({ ensure: { url: url, method: "POST" } });
        proxy.ensure(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return ;
          }
          promise.resolve();
        });

        return promise;

      });
    }
  }
  try {
    module.exports = AA_aa_enumext_VM_extend;
  } catch (error) {

  }
  return AA_aa_enumext_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_enumext_VM.Extend.js